import { useSecureUrl } from "../hooks/useSecureHook";

const SecureImage = ({ url,fallback = null, ...props }) => {
  const src = useSecureUrl(url);
  // console.log("srcIMAGESECURE", src);
  return <img src={src}  {...props} />;
};

export default SecureImage;